module.exports = __webpack_public_path__ + "img/pr-2.3de3612b.png";